import React, { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Selection state + delete call for a list of leads or quotes.
export const useBulkDelete = (kind, token, onDeleted) => {
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const toggleAll = (ids) => setSel((s) => (ids.length && ids.every((id) => s.includes(id)) ? s.filter((x) => !ids.includes(x)) : [...new Set([...s, ...ids])]));
  const remove = async (ids) => {
    if (!ids.length || !window.confirm(`Move ${ids.length} ${ids.length === 1 ? "entry" : "entries"} to Trash? You can restore from the Trash tab for 30 days.`)) return;
    setBusy(true);
    const r = await fetch(`${API}/admin/${kind}/delete`, { method: "POST", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify({ ids }) });
    setBusy(false);
    if (!r.ok) return window.alert("Could not delete. Please try again.");
    setSel((s) => s.filter((x) => !ids.includes(x)));
    onDeleted(ids);
  };
  return { sel, busy, toggle, toggleAll, remove };
};

export const SelectAllBox = ({ bd, ids, testid }) => (
  <input type="checkbox" aria-label="Select all" data-testid={testid} className="w-4 h-4 accent-[#3b9dff]"
    checked={ids.length > 0 && ids.every((id) => bd.sel.includes(id))} onChange={() => bd.toggleAll(ids)} />
);

export const RowBox = ({ bd, id, testid }) => (
  <input type="checkbox" aria-label="Select" data-testid={testid} className="w-4 h-4 accent-[#3b9dff]" checked={bd.sel.includes(id)} onChange={() => bd.toggle(id)} />
);

export const RowDelete = ({ bd, id, testid }) => (
  <button onClick={() => bd.remove([id])} disabled={bd.busy} data-testid={testid} title="Delete" className="text-slate-400 hover:text-red-500 disabled:opacity-50"><Trash2 className="w-4 h-4" /></button>
);

export const DeleteBar = ({ bd, testid }) => bd.sel.length > 0 && (
  <div className="flex items-center gap-3 mb-3 bg-red-50 border border-red-200 rounded-xl px-4 py-2.5" data-testid={`${testid}-bar`}>
    <span className="text-sm text-red-700 font-semibold" data-testid={`${testid}-count`}>{bd.sel.length} selected</span>
    <button onClick={() => bd.remove(bd.sel)} disabled={bd.busy} data-testid={`${testid}-btn`} className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-red-600 hover:bg-red-700 text-white text-sm font-semibold disabled:opacity-60">
      {bd.busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />} Delete selected
    </button>
    <button onClick={() => bd.toggleAll(bd.sel)} data-testid={`${testid}-clear`} className="text-sm text-slate-500 hover:text-slate-700">Clear</button>
  </div>
);
